import { useCallback, useState } from "react";

export function useBoolean(defaultTo = false): [boolean, () => void, () => void, () => void] {
  const [value, setValue] = useState(defaultTo)

  const setTrue = useCallback(() => setValue(true), [])
  const setFalse = useCallback(() => setValue(false), [])
  const toggle = useCallback(() => setValue(!value), [value])

  return [value, setTrue, setFalse, toggle]
}